import 'dva/fetch';
import fetchJsonp from 'fetch-jsonp';
import { isPureWeblite } from '@alife/im-env';
import { _log } from './log';
import utils from './utils';

const WHITE_LIST = [
  'onetalk.alibaba.com/message/getChatMessageList.htm',
  'onetalk.alibaba.com/message/getRecentContactList.htm',
];

const csrfTokenKey = window.csrfTokenKey || window.GDATA && window.GDATA.system && window.GDATA.system.csrfTokenKey;
const csrfTokenVal = window.csrfTokenVal || window.GDATA && window.GDATA.system && window.GDATA.system.csrfTokenVal;

export async function jsonp(url, params) {
  var cookie = document.cookie;
  var match = cookie && cookie.match(/(?:^|;)\s*xman_us_t\s*=\s*([^;]+)/);
  if (match) {
    match = match[1].match(/(?:^|&)\s*ctoken\s*=\s*([^&]+)/);
  }
  let ctoken = match && match[1];
  // tbtoken
  match = cookie && cookie.match(/(?:^|;)\s*_tb_token_\s*=\s*([^;]+)/);
  let tbToken = match && match[1];
  let query = Object.assign({}, params, { ctoken, _tb_token_: tbToken });

  query = buildQuery(query);
  return fetchJsonp(`${url}?${query}`).then((response) => {
    return response.json();
  }).catch(() => {
    return {
      code: 500,
      data: {}
    };
  });
}

class RequestError extends Error {
  constructor(msg, res) {
    super(msg, res);
  }
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new RequestError(response.statusText, response);
  throw error;
}

function buildQuery(params) {
  let ret = {}, querystring = '', key, query = [];
  for (key in params) {
    if (typeof params[key] === 'object') {
      params[key] = JSON.stringify(params[key]);
    }
    ret[key] = params[key];
  }
  for (key in ret) {
    query[query.length] = `${encodeURIComponent(key)}=${encodeURIComponent(ret[key])}`;
  }
  querystring = query.join('&');
  return querystring;
}

function serialize(obj) {
  const s = [];
  /* eslint-disable no-useless-escape */
  const rbracket = /\[\]$/;
  /* eslint-enable */

  const add = function (k, v) {
    v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
    s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
  };
  const buildParams = function (prefix, obj) {
    let i, len, key;

    if (prefix) {
      if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          if (rbracket.test(prefix)) {
            add(prefix, obj[i]);
          } else {
            buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i]);
          }
        }
      } else if (obj && String(obj) === '[object Object]') {
        for (key in obj) {
          buildParams(prefix + '[' + key + ']', obj[key]);
        }
      } else {
        add(prefix, obj);
      }
    } else {
      if (obj && typeof obj === 'object') {
        for (key in obj) {
          buildParams(key, obj[key]);
        }
      }
    }
    return s;
  };

  return buildParams('', obj).join('&');
}

function addQueryString(url, qs) {
  if (!qs) {
    return url;
  }

  const connector = url.indexOf('?') > -1 ? '&' : '?';
  return `${url}${connector}${qs}`;
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export async function request(url, options = {}) {
  const initOptions = {
    cache: 'no-cache',
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    method: 'GET',
    mode: 'cors'
  };
  Object.assign(initOptions, options);
  if (initOptions.body) {
    // message.alibaba.com域名下的post请求需要添加csrftokan
    if (initOptions.method === 'POST' && url.indexOf('message.alibaba.com') !== -1 && csrfTokenKey && csrfTokenVal) {
      initOptions.body[csrfTokenKey] = csrfTokenVal;
    }
    let serializeData;
    if (initOptions.headers && initOptions.headers['Content-Type'] === 'application/json') {
      serializeData = JSON.stringify(initOptions.body);
    } else {
      serializeData = serialize(initOptions.body);
    }
    if (initOptions.method === 'GET') {
      url = addQueryString(url, serializeData);
      // 当是GET请求时，不允许携带body字段，故需要删除
      delete initOptions.body;
    } else {
      initOptions.body = serializeData;
    }
  }
  try {
    const startTime = +new Date;
    const response = await fetch(url, initOptions);
    const costTime = +new Date - startTime;

    checkStatus(response);

    let data = await response.json();
    if (!data) {
      data = {};
    }
    const ext = `commonRequest&url=${encodeURIComponent(url)}&costTime=${costTime}&code=${data.code}&accountId=${utils.getAccountId()}&traceId=${response.headers.get('x-eagleeye-id')}&time=${Date.now()}`;
    // 请求通用打点，记录请求url、耗时、响应内容
    _log(ext);
    // 重定向到登录页需要排除weblite场景
    if (data.code * 1 === 501 && !isPureWeblite) {
      window.location.href = `//passport.alibaba.com/icbu_login.htm?return_url=${encodeURIComponent(location.href)}`;
    }

    const ret = {
      data,
      headers: {},
    };
    // 白名单打点
    if (WHITE_LIST.indexOf(url.replace('//', '')) >= 0) {
      if (data.data && data.data.list && data.data.list.length === 0) {
        _log(`listEmpty&traceId=${response.headers.get('x-eagleeye-id')}&url=${encodeURIComponent(url)}&time=${Date.now()}&accountId=${utils.getAccountId()}`);
      }
    }

    return ret;
  } catch (e) {
    const ext = `commonRequest&error=1&url=${encodeURIComponent(url)}&accountId=${utils.getAccountId()}&time=${Date.now()}&traceId=${response.headers.get('x-eagleeye-id')}`;
    _log(ext);
    return {
      data: {
        code: '-1000',
        message: `im-common request error: url is ${url}, message is ${e.message}`
      }
    };
  }

}
